/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `GOVERNANCE` - GOVERNANCE
 * * `RISKPROFILE` - RISKPROFILE
 * @export
 */
export const WhichPageEnum = {
  governance: 'GOVERNANCE',
  riskprofile: 'RISKPROFILE',
} as const;
export type WhichPageEnum = (typeof WhichPageEnum)[keyof typeof WhichPageEnum];

export function instanceOfWhichPageEnum(value: any): boolean {
  for (const key in WhichPageEnum) {
    if (Object.prototype.hasOwnProperty.call(WhichPageEnum, key)) {
      if ((WhichPageEnum as Record<string, WhichPageEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function WhichPageEnumFromJSON(json: any): WhichPageEnum {
  return WhichPageEnumFromJSONTyped(json, false);
}

export function WhichPageEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): WhichPageEnum {
  return json as WhichPageEnum;
}

export function WhichPageEnumToJSON(value?: WhichPageEnum | null): any {
  return value as any;
}
